import React, { useContext } from "react";
import NavigationLabel from "./NavigationLabel";
import { Box } from "@chakra-ui/react";
import Logo from "../general/Logo";
import { NeedHelp } from "../../../components/common/general";
import { useLocation } from "react-router-dom";
import { sendTrackingEvent } from "../utils/gtm";
import { AppContext } from "../../../context/ApplicationContext";
import { isProgramPresent } from "../utils/isProgramPresent";

interface Props {
  width: string | number;
  height: string | number;
  topLabelsList: {
    key: number | string;
    title: string | number;
    type: "primary" | "secondary" | "tab" | "hamburger-label";
    badgeComponent?: React.ReactElement; // completely optional
    iconForPrimary?: React.ReactElement; // required if type is primary
    path: string;
    link?: string;
    isExternal?: boolean;
  }[];
  bottomLabelsList?: {
    key: number | string;
    title: string | number;
    type: "primary" | "secondary" | "tab" | "hamburger-label";
    badgeComponent?: React.ReactElement; // completely optional
    iconForPrimary?: React.ReactElement; // required if type is primary
    path: string;
    link?: string;
    isExternal?: boolean;
  }[];
}

const LeftNavigation = ({ width, height, topLabelsList, bottomLabelsList }: Props) => {
  const location = useLocation();
  const state = useContext(AppContext)[0];

  const handleSendEvent = (title: string | number) => {
    switch (title) {
      case "Courses":
        sendTrackingEvent({ event: "dash-courses", eventLabel: location.pathname });
        break;
      case "Contests":
        sendTrackingEvent({
          event: "dash-contests",
          eventLabel: location.pathname,
          userId: state.profileData?.slug || "",
        });
        break;
      case "Events" || "Events & Contests":
        sendTrackingEvent({
          event: "dash-events",
          eventLabel: location.pathname,
        });
        break;
      case "Self learning":
        sendTrackingEvent({ event: "dash-self_learning", eventLabel: location.pathname });
        break;
      case "Referral Program":
        sendTrackingEvent({ event: "dash-referral_program", eventLabel: location.pathname });
        break;
      case "Documents":
        sendTrackingEvent({ event: "dash-candidate_documents", eventLabel: location.pathname });
        break;
      case "PAP":
        sendTrackingEvent({ event: "dash-isa", eventLabel: location.pathname });
        break;
      case "FAQs":
        sendTrackingEvent({ event: "dash-faqs", eventLabel: location.pathname });
        break;
      default:
        return;
    }
  };
  return (
    <Box
      position={"fixed"}
      d={"flex"}
      h={height}
      w={width}
      flexDirection={"column"}
      pb={4}
      boxShadow={" -1px 0px 0px 0px #D9D9D9 inset"}
      pr={0.5}
      display={{ base: "none", md: "flex" }}
    >
      <button
        onClick={() => {
          window.open(state.isScholar ? "https://www.prepleaf.com" : "https://www.masaischool.com");
        }}
      >
        <Box
          d={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          h={"56px"}
          // mb={12}
          // mt={2}
          mx={6}
          alignSelf={"center"}
          w={`calc(100% - 48px)`}
        >
          <Logo />
        </Box>
      </button>
      <Box>
        {topLabelsList.map((label) => (
          <Box
            key={label.key}
            onClick={() => {
              handleSendEvent(label.title);
            }}
            id={label.key === 2 ? "contest-nav-desktop" : ""}
            display={label.path.includes("contests") ? "none" : "block"}
          >
            <NavigationLabel
              title={label.title}
              type={label.type}
              iconForPrimary={label.iconForPrimary}
              badgeComponent={label.badgeComponent}
              active={label.path === location.pathname}
              path={label.path}
            />
          </Box>
        ))}
      </Box>
      {bottomLabelsList && (
        <Box mt={"auto"}>
          {bottomLabelsList.map((label) => (
            <Box
              key={label.key}
              onClick={() => {
                handleSendEvent(label.title);
              }}
              display={
                (label.path.includes("isa") &&
                  isProgramPresent("scholar", state.profileData?.programs)) ||
                (label.path.includes("isa") &&
                  isProgramPresent("cap", state.profileData?.programs)) ||
                (label.path.includes("isa") && state.isScholar)
                  ? "none"
                  : "block"
              }
            >
              <NavigationLabel
                title={label.title}
                type={label.type}
                iconForPrimary={label.iconForPrimary}
                badgeComponent={label.badgeComponent}
                active={label.path === location.pathname}
                path={label.path}
                link={label.link}
                isExternal={label.isExternal}
              />
            </Box>
          ))}
        </Box>
      )}
      <Box m={4} mb={0}>
        <NeedHelp link="https://zoom.us/meeting/register/tJMlfu-prTIqE9C1Ol8PyAxAmDQDbV6BtCD-" />
      </Box>
    </Box>
  );
};

export default LeftNavigation;
